var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import classNames from 'classnames';
import React, { forwardRef, memo, useContext, useImperativeHandle, useMemo, useRef } from 'react';
import ConfigProvider from '@baifendian/adhere-ui-configprovider';
import { FlexContext } from './Context';
import { useGap, useGrid, useTrigger } from './Hooks';
import { getGridStyle } from './Util';
var selectorPrefix = 'adhere-ui-flex-layout-fixed';
export var gridCount = 24;
/**
 * Fixed
 * @param {FixedProps} props
 * @param ref
 * @constructor
 */
var Fixed = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    style = props.style,
    fit = props.fit,
    span = props.span,
    trigger = props.trigger,
    _a = props.collapseDirection,
    collapseDirection = _a === void 0 ? 'L' : _a,
    _b = props.collapsedSize,
    collapsedSize = _b === void 0 ? 80 : _b,
    _c = props.defaultCollapsible,
    defaultCollapsible = _c === void 0 ? false : _c,
    onCollapse = props.onCollapse,
    attrs = __rest(props, ["className", "children", "style", "fit", "span", "trigger", "collapseDirection", "collapsedSize", "defaultCollapsible", "onCollapse"]);
  var media = useContext(ConfigProvider.Context).media;
  var _d = useContext(FlexContext),
    _e = _d.gutter,
    gutter = _e === void 0 ? 0 : _e,
    direction = _d.direction,
    contextChildren = _d.children;
  var elRef = useRef(null);
  var isUseGrid = useGrid(props);
  var isUseGap = useGap(gutter);
  var _f = useTrigger({
      trigger: trigger,
      collapseDirection: collapseDirection,
      collapsedSize: collapsedSize,
      defaultCollapsible: defaultCollapsible,
      onCollapse: onCollapse,
      selectorPrefix: selectorPrefix,
      elRef: elRef
    }),
    renderTrigger = _f.renderTrigger,
    /*collapseClassName,*/collapseStyle = _f.collapseStyle;
  var classList = useMemo(function () {
    var _a;
    return classNames(selectorPrefix, className !== null && className !== void 0 ? className : '', (_a = {}, _a["".concat(selectorPrefix, "-fit")] = fit, _a["".concat(selectorPrefix, "-col-").concat(span)] = isUseGrid, _a["".concat(selectorPrefix, "-gap")] = isUseGap, _a));
  }, [className, span, fit, isUseGap, isUseGrid /*collapseClassName*/]);
  var styleList = useMemo(function () {
    var defaultStyle = style !== null && style !== void 0 ? style : {};
    var gridStyle = isUseGap ? getGridStyle({
      gutter: gutter,
      span: span,
      children: contextChildren,
      direction: direction,
      media: media
    }) : {};
    return __assign(__assign(__assign({}, defaultStyle), gridStyle), collapseStyle !== null && collapseStyle !== void 0 ? collapseStyle : {});
  }, [style, gutter, collapseStyle, isUseGap, direction, media, span, contextChildren]);
  useImperativeHandle(ref, function () {
    return {
      getEl: function () {
        return elRef.current;
      }
    };
  });
  return /*#__PURE__*/React.createElement("div", __assign({
    ref: elRef
  }, attrs, {
    className: classNames(classList),
    style: styleList
  }), children, renderTrigger());
}));
Fixed.displayName = 'Fixed';
export default Fixed;